// extracted by mini-css-extract-plugin
export default {"address":"address","location":"location","name":"name"};